export const ANFORDERUNGART_BEHOERDLICHE_FESTLEGUNG = "BEHOERDLICHE_FESTLEGUNG";
export const ANFORDERUNGART_SELBSTUEBERWACHUNGSAUFLAGE = "SELBSTUEBERWACHUNGSAUFLAGE";

export function anforderungsartIdToObj(id) {
    switch (id) {
        case ANFORDERUNGART_BEHOERDLICHE_FESTLEGUNG:
            return { id: ANFORDERUNGART_BEHOERDLICHE_FESTLEGUNG, value: "Behördliche Festlegung" };
        case ANFORDERUNGART_SELBSTUEBERWACHUNGSAUFLAGE:
            return { id: ANFORDERUNGART_SELBSTUEBERWACHUNGSAUFLAGE, value: "Selbstüberwachungsauflage" };
        default:
            return null;
    }
}
